import ModalViewModel, {
  ModalViewModelClosingSignal,
} from '../../../infra/ModalViewModel'
import Job from '../../Job'
import once from 'lodash/once'
import { task } from 'mobx-task'
import { CancellationToken } from '../../../infra/cancellation'

/**
 * Delete Job view model.
 */
export default class DeleteJobViewModel extends ModalViewModel {
  constructor(
    public job: Job,
    private _delete: (job: Job) => Promise<unknown>,
    closingSignal?: ModalViewModelClosingSignal,
  ) {
    super(closingSignal)
  }

  /**
   * Deletes the Job.
   */
  performDelete = task.resolved(async () => {
    await this._delete(this.job)
    this.close()
  })

  /**
   * Default instance.
   */
  static get none() {
    return lazyNone()
  }
}

const lazyNone = once(
  () =>
    new DeleteJobViewModel(
      Job.none,
      () => Promise.resolve(),
      CancellationToken.cancelled,
    ),
)
